module.exports = __webpack_public_path__ + "static/GloberRegular-3fcd625845b549b747e11305cdc33c48.woff2";